import { Component, OnInit } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-view-sample-detail',
  templateUrl: './view-sample-detail.component.html',
  styleUrls: ['./view-sample-detail.component.scss']
})
export class ViewSampleDetailComponent implements OnInit {

  sampleId!: any;
  product!: any;
  vehicle!: any;

  constructor(private route: ActivatedRoute, private fswService: FswService, private authService: AuthService) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.sampleId = +params['sampleId']; // (+) converts string 'id' to a number
​
      // In a real app: dispatch action to load the details here.
   });
    this.getTestingDetailsBySampleId()
  }

  testings: any[] = [];
  testings1:any[]=[];
  testings2:any[]=[];
  userName: any;

  getTestingDetailsBySampleId() {

    //this.userName = this.authService.getUserName(); 
    this.fswService.getSampleDetails(this.sampleId)
      .subscribe(res => {
        if(res)
        {
          // this.product=res[0].productName;
         //  this.vehicle=res[0].vehicleNo;
           this.testings1=res;
          
          this.fswService.getOtherSampleDetails(this.sampleId).subscribe(res1=>
            {
                if(res1.length>0)
                {
                  this.testings2=res1;
                 
                  this.testings=[...this.testings1,...this.testings2]; 
                 
                }
                else{
                  this.testings=[...this.testings,...this.testings1];
                }
             
            }
          )
        }
        
      debugger
        //  this.testings = res;
        //  this.product=res[0].productName;
        //  this.vehicle=res[0].vehicleNo;
        
      });
  }

}
